const UserPurposeValues = {
    NEW_CAR: 'new-car',
    RENEWAL: 'renewal',
    BROWSING: 'browsing',
};

export default UserPurposeValues;
